/**
 * @file: RemarkField.tsx
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * The calm multi-line remark input for the follow-up note.
 */

import { LD } from '@euler/app/flows/leads/pages/detail/components/leadDetailKit';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { TextInput } from 'react-native';

export const RemarkField = ({
  value,
  onChangeText,
}: {
  value: string;
  onChangeText: (s: string) => void;
}) => {
  const { rpx } = useResponsiveContext();
  return (
    <TextInput
      value={value}
      onChangeText={onChangeText}
      multiline
      placeholder="填写跟进备注"
      placeholderTextColor={LD.mist}
      textAlignVertical="top"
      style={{
        backgroundColor: LD.surface,
        borderRadius: rpx(12),
        borderWidth: 1,
        borderColor: LD.hairline,
        minHeight: rpx(96),
        paddingHorizontal: rpx(14),
        paddingVertical: rpx(12),
        fontSize: rpx(15),
        lineHeight: rpx(22),
        color: LD.ink,
      }}
    />
  );
};
